<template>
  <iMineTemplate
    :page-title="pageTitle"
    :actived-parent-key="activedParentKey"
    :actived-key="activedKey"
  >
    <div
      slot="rightContent"
      class="alwaysbuyslist"
    >
      <div class="collection">常购清单</div>
      <!-- <BuyCarComponent is-always-buys-com /> -->
      <SearchPageItem />
      <!-- <div class="goods"
                 v-if="dataList&&dataList.length">
                <div v-for="item in dataList"
                     :key="item.Id"
                     class="goods-cell"
                     @click.stop="showRouter(item)">
                    <div class="goods-b">
                        <iProductDetail :product="item" />
                    </div>
                </div>
            </div>
            <iPagination v-if="dataList&&dataList.length"
                         :currentPage.sync="pageindex"
                         :limit.sync="pageSize"
                         :totalCount="totalCount"
                         @turn="loadData" />
            <EmptyControl style="margin:20px 0 ;padding: 100px 0;"
                          v-if="!dataList.length"
                          type="order"
                          text="你还没有下订单哦~">
            </EmptyControl> -->
    </div>
  </iMineTemplate>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import { LinkTypeCode } from '../../dictionary/base'
import iProductDetail from '@/components/ProductDetail'
import BuyCarComponent from '@/views/buyCar/QuickBuyCar.vue'
import SearchPageItem from './components/SearchPageItem.vue'
export default {
  name: 'AlwaysBuysList',
  components: {
    SearchPageItem,
    iProductDetail,
    BuyCarComponent
  },
  mixins: [BaseMixin],
  data() {
    return {
      pageTitle: ['我的收藏', '常购清单'],
      activedParentKey: 3,
      activedKey: 31,

      pageindex: 1,
      pageSize: 8,
      totalCount: 0,

      dataList: [],

      url: {
        list: '/api_order/Orders/GetPurchasedGoods'
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    showRouter: function(item) {
      this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Id, '_blank')
    },
    async loadData() {
      this.$hys.openLoading()
      const res = await this.getAction(this.url.list, {
        pageNo: this.pageindex,
        pagesize: this.pageSize
      })
      this.$hys.clearLoading()
      this.totalCount = res.Count
      if (res.IsSuccess) {
        const dataArr = []
        res.Data.map(item => {
          const tags = []
          const SalesPromotionRules =
                        item.ProductEntity &&
                            item.ProductEntity.SalesPromotions.length
                          ? item.ProductEntity.SalesPromotions[0].SalesPromotionRules
                          : null
          if (
            SalesPromotionRules &&
                        SalesPromotionRules[0].SalesPromotionRuleFullPresents &&
                        SalesPromotionRules &&
                        SalesPromotionRules[0].SalesPromotionRuleFullPresents.length
          ) { tags.push('满赠') }
          // item.CommodityListProperties //
          const PriceLimit = item.ProductEntity && item.ProductEntity.PriceLimit || 0
          const PriceActivity = item.ProductEntity && item.ProductEntity.PriceActivity || 0
          let differencePrice = 0
          if (PriceLimit && ((!PriceActivity || PriceActivity >= PriceLimit))) {
            differencePrice = Number(item.CollectionPrice - PriceLimit)
          } else if ((PriceLimit && (PriceActivity && PriceActivity <= PriceLimit)) || PriceActivity) {
            differencePrice = Number(item.CollectionPrice - PriceActivity)
          } else {
            differencePrice = Number(item.CollectionPrice - PriceLimit)
          }
          const l = {
            checkBoxShow: false,
            checked: false,
            cId: item.Id,
            CollectingBusinessId: item.CollectingBusinessId,
            productId: item.ProductEntity && item.ProductEntity.Id,
            img: item.ProductEntity && item.ProductEntity.Logo,
            name: item.ProductEntity && this._showProductTitle(item.ProductEntity.SkuName, item.ProductEntity
              .OperationName),
            Specifications: item.ProductEntity && item.ProductEntity.SpecificationsName,
            PriceLimit: PriceLimit,
            PriceActivity: PriceActivity,
            RetailPrice: item.ProductEntity && item.ProductEntity.RetailPrice,
            tag: tags,
            SalesPromotionRules: item.ProductEntity && item.ProductEntity.SalesPromotions
              ? item.ProductEntity.SalesPromotions.SalesPromotionRules : [],
            ...item.ProductEntity,
            Stock: item.ProductEntity && item.ProductEntity.Stock,
            IsSoldOut: item.ProductEntity && !item.ProductEntity.IsPutaway,
            differencePrice: differencePrice,
            ArrivalNotice: item.ProductEntity && item.ProductEntity.ArrivalNotice,
            EstimatedTime: item.ProductEntity && item.ProductEntity.EstimatedTime
          }
          if (this.dataList.findIndex(tag => tag.cId == l.cId) == -1) {
            dataArr.push(l)
          }
        })
        this.dataList = dataArr
        console.log(dataArr)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.alwaysbuyslist {
  padding: 0 10px;
  width: 1000px;
  background: rgba(255, 255, 255, 1);
  box-sizing: content-box;

  .collection {
    padding-top: 20px;
    padding-left: 20px;
    font-size: 18px;
    text-align: left;
    color: #222222;
    color: rgba(34, 34, 34, 1);
    background-color: #FFFFFF;
    box-sizing: border-box;
  }

  .goods {
    display: flex;
    padding: 10px;
    padding-bottom: 20px;
    flex-wrap: wrap;

    .goods-cell {
      padding: 10px;
      width: 25%;
    }

    .goods-b {
      border: 1px solid #E8E8E8;
    }

    #goods-item {
      margin-top: 20px;
      margin-left: 20px;
      border: 1px solid rgba(232, 232, 232, 1);
      border-radius: 2px;
    }
  }
}

.empty {
  margin: 0 auto;
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 100px;
  margin-left: 20px;
  border-top: 1px #E8E8E8 solid;
  padding: 100px 0;
  background-color: #FFFFFF;
  box-sizing: border-box;

  img {
    max-width: 260px;
    max-height: 260px;
  }

  .ecar-txt {
    margin-top: 30px;
    font-size: 16px;
    color: rgba(119, 119, 119, 1);
  }
}

.all-checkbox {
  padding-left: 15px;
  width: 50%;
}

/deep/ .checkBox {
  display: flex;
  justify-content: center;
  align-items: center;
  width: .6rem;
}

.clearBox {
  display: flex;
  justify-content: center;
  width: .8rem;
}

/deep/ .van-tab__text {
  padding: .2rem 0;
  font-size: .28rem;
  color: #222222;
}

/deep/ #goods-product-item {
  margin-bottom: .15rem;
  padding-top: 0;

  .productItem .goods-image {
    min-width: 2.54rem;
  }

  /deep/ .van-button--disabled {
    margin-left: .24rem;
  }
}
</style>
